<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 缩略图 strat -->
      <el-tab-pane label="缩略图" name="first">
        <div class="block">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="Listorder" label="排序" min-width="10%"></el-table-column>
          <el-table-column prop="Pic" label="新闻缩略图" min-width="75%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 缩略图 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" name="second">
        <el-form :model="addData" ref="addDataRef" label-width="120px">
          <el-form-item label="缩略图" class="addAdminForm">
            <el-input v-model="addData.pic" placeholder="请输入缩略图"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <!-- 修改 start -->
      <el-tab-pane label="修改" name="three">
        <el-form :model="editData" ref="editDataRef" label-width="120px">
          <el-form-item label="缩略图" class="addAdminForm">
            <el-input v-model="editData.pic" placeholder="请输入缩略图"></el-input>
          </el-form-item>
          <el-form-item label="排序" class="addAdminForm">
            <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickModify">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      newsid: '',
      addData: {
        pic: ''
      },
      editData: {
        id: '',
        pic: '',
        listorder: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.newsid = row.Id
      this.GetKgjtWebsiteNewsPicNum()
      this.GetKgjtWebsiteNewsPicList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteNewsPicList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.AddKgjtWebsiteNewsPic()
    },
    clickEdit (row) {
      this.editData.id = row.Id
      this.editData.pic = row.Pic
      this.editData.listorder = row.Listorder
      this.activeName = 'three'
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteNewsPic(row)
      })
    },
    clickModify () {
      this.EditKgjtWebsiteNewsPic()
    },
    GetKgjtWebsiteNewsPicList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newsid: that.newsid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteNewsPicList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteNewsPicNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newsid: that.newsid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteNewsPicNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteNewsPic: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newsid: that.newsid,
        pic: that.addData.pic
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteNewsPic, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteNewsPicNum()
            that.GetKgjtWebsiteNewsPicList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    EditKgjtWebsiteNewsPic: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newsid: that.newsid,
        id: that.editData.id,
        pic: that.editData.pic,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteNewsPic, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteNewsPicList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteNewsPic: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteNewsPic, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteNewsPicNum()
          that.GetKgjtWebsiteNewsPicList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
